import type { CategoryCard } from "@v1/components/left-bar/sections-pane/TemplateCategories";

import * as React from "react";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import twMerge from "@replo/design-system/utils/twMerge";
import { selectLeftBarWidth } from "@v1/reducers/ui-reducer";
import { useEditorSelector } from "@v1/store/store";
import { ChevronRight } from "lucide-react";

import TemplateList from "./TemplateList";

interface TemplateCategoryMenuCardProps {
  category: CategoryCard;
  openedMenu: string;
  hideMenuContent: boolean;
}

const TemplateCategoryMenuCard: React.FC<TemplateCategoryMenuCardProps> = ({
  category,
  openedMenu,
  hideMenuContent,
}) => {
  const leftBarWidth = useEditorSelector(selectLeftBarWidth);

  return (
    <NavigationMenu.Item
      key={category.value}
      value={category.value}
      className="list-none"
    >
      <NavigationMenu.Trigger
        className={twMerge(
          "flex w-full items-center justify-between rounded-sm p-2 text-xs font-semibold",
          openedMenu === category.value ? "bg-sheet" : "",
        )}
        onClick={(e) => {
          if (openedMenu === category.value) {
            e.preventDefault();
          }
        }}
      >
        <div className="flex items-center gap-2">
          <div
            className={twMerge(
              "bg-surface border-0.5 border-border rounded-md p-2",
              openedMenu === category.value && "bg-white",
            )}
          >
            <category.icon
              size={18}
              className={twMerge(
                "text-muted",
                openedMenu === category.value && "text-default",
              )}
            />
          </div>
          <div className="flex flex-col text-start">
            <span>{category.name}</span>
            {category.description && (
              <span className="text-muted font-normal">
                {category.description}
              </span>
            )}
          </div>
        </div>
        <ChevronRight size={16} className="text-placeholder" />
      </NavigationMenu.Trigger>
      <NavigationMenu.Content
        id="sections-pane-template-list-wrapper"
        style={{
          left: leftBarWidth,
          top: 0,
        }}
        className={twMerge(
          "border-border no-scrollbar shadow-r-lg absolute z-[2147480003] h-full w-80 overflow-y-scroll rounded-r-lg border-b border-r border-t bg-white",
          openedMenu !== category.value || hideMenuContent ? "invisible" : "",
        )}
        onPointerLeave={(e) => {
          // Note (Ben O. 2025-03-03): This is here to prevent the opened saved menu from closing when we right click to delete saved templates.
          if (openedMenu === "saved") {
            e.preventDefault();
          }
        }}
      >
        <TemplateList category={category} />
      </NavigationMenu.Content>
    </NavigationMenu.Item>
  );
};

export default TemplateCategoryMenuCard;
